import { useEffect, useState, useRef } from "react";
import { api, resolveImage } from "@/lib/api";
import { useLenis } from "@/hooks/useLenis";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { BrandMarquee } from "@/components/site/BrandMarquee";
import { Categories } from "@/components/site/Categories";
import { ProductsSection } from "@/components/site/ProductsSection";
import { VideosSection } from "@/components/site/VideosSection";
import { Manifesto } from "@/components/site/Manifesto";
import { Contact } from "@/components/site/Contact";
import { Footer } from "@/components/site/Footer";

export default function HomePage() {
  const [content, setContent] = useState(null);
  const [products, setProducts] = useState([]);
  const [videos, setVideos] = useState([]);
  const [activeCat, setActiveCat] = useState(null);
  useLenis();

  useEffect(() => {
    api.get("/content").then((res) => setContent(res.data)).catch(() => {});
    api.get("/products").then((res) => setProducts(res.data)).catch(() => {});
    api.get("/videos").then((res) => setVideos(res.data)).catch(() => {});
  }, []);

  if (!content) {
    return (
      <div className="min-h-screen grid place-items-center bg-ad-black">
        <div className="font-display text-3xl uppercase tracking-widest metallic-text animate-pulse">
          American Dream
        </div>
      </div>
    );
  }

  const logo = resolveImage(content.hero?.logo_url);
  const scrollToContact = () => document.getElementById("contact")?.scrollIntoView({ behavior: "smooth" });
  const goToCategory = (catId) => {
    setActiveCat(catId);
    setTimeout(() => document.getElementById("sale")?.scrollIntoView({ behavior: "smooth" }), 60);
  };

  return (
    <div className="grain relative bg-ad-black">
      <Header business={content.business} logo={logo} />
      <Hero hero={content.hero} business={content.business} />
      <BrandMarquee text={content.marquee_text} />
      <Categories categories={content.categories || []} onCategory={goToCategory} />
      <ProductsSection
        products={products}
        phone={content.business?.phones?.[0]}
        activeCat={activeCat}
        setActiveCat={setActiveCat}
      />
      <VideosSection videos={videos} />
      <Manifesto manifesto={content.manifesto || []} about={content.about} />
      <Contact business={content.business} mapEmbed={content.map_embed} />
      <Footer business={content.business} logo={logo} />
    </div>
  );
}
